/**
 * @namespace GlobalMethods
 */
export default {
    /**
     * @param {String} status Дата в виде строки
     * @returns {Date|Error} Ошибка или дата в формате дд.мм.гггг
     * 
     * @memberof GlobalMethods
     */
    toDate: (status) => {
        try {
            const dateProposal = new Date(status);
            const day =  Number(dateProposal.getDate()) < 10 ? `0${dateProposal.getDate()}` : dateProposal.getDate();
            const month =  Number(dateProposal.getMonth() + 1) < 10 ? `0${dateProposal.getMonth() + 1}` : dateProposal.getMonth() + 1;
            const date = `${day}.${month}.${dateProposal.getFullYear()}`;
    
            return date;
        } catch (error) {
            this.$toasted.show(`Произошла ошибка! ${error}`, { type: 'error', duration: 3000 });
            
            return error;
        }
    },
    toDateTime: (status) => {
        try {
            const dateProposal = new Date(status);
            const day =  Number(dateProposal.getDate()) < 10 ? `0${dateProposal.getDate()}` : dateProposal.getDate();
            const month =  Number(dateProposal.getMonth() + 1) < 10 ? `0${dateProposal.getMonth() + 1}` : dateProposal.getMonth() + 1;
            const m = Number(dateProposal.getMinutes()) < 10 ? `0${dateProposal.getMinutes()}` : dateProposal.getMinutes()
            const h = Number(dateProposal.getHours()) < 10 ? `0${dateProposal.getHours()}` : dateProposal.getHours()

            const date = `${day}.${month}.${dateProposal.getFullYear()} ${h}:${m}`;
    
            return date;
        } catch (error) {
            this.$toasted.show(`Произошла ошибка! ${error}`, { type: 'error', duration: 3000 });
            
            return error;
        }
    },

    ToHmsFromSeconds(totalSeconds) {
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        const formattedHours = String(hours).padStart(2, '0');
        const formattedMinutes = String(minutes).padStart(2, '0');
        const formattedSeconds = String(seconds).padStart(2, '0');

        return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
    },

    proposalStatusDescr: (status_id) => {
        try {    
            const statuses = [
                { status_id: 0, slug: 'draft', descr: '---'},
                { status_id: 1, slug: 'draft', descr: 'Черновик'},
                { status_id: 2, slug: 'created', descr: 'Входящие заявки'},
                { status_id: 3, slug: 'expertise', descr: 'На экспертизе'},
                { status_id: 4, slug: 'statement', descr: 'На утверждении'},
                { status_id: 5, slug: 'approve', descr: 'Принята'},
                { status_id: 6, slug: 'modification', descr: 'На доработке'},
                { status_id: 7, slug: 'scheduled', descr: 'Назначено время'},
                { status_id: 8, slug: 'need_report', descr: 'Ожидает отчёта'},
                { status_id: 9, slug: 'done', descr: 'Выполнена'},
                { status_id: 10, slug: 'publication', descr: 'Статья'},
                { status_id: 11, slug: 'reject', descr: 'Отклонена'},
                { status_id: 12, slug: 'deleted', descr: 'Удалена'},
                { status_id: 13, slug: 'archived', descr: 'Архив'},
                { status_id: 14, slug: 'not_realized', descr: 'не реализована'},
            ];
            return statuses[status_id].descr;
        } catch (error) {
            this.$toasted.show(`Произошла ошибка! ${error}`, { type: 'error', duration: 3000 });
            
            return error;
        }

    },
}